import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import { useUpdateEnterpricePaymentPlans } from '@features/payments/hooks/useUpdateEnterpricePaymentPlans';
import CloseIcon from '@mui/icons-material/Close';
import { UpdateIcon } from '../../../../vectors/index';

type EnterpricePlanUpdateConfirmationModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  planId: string;
};

const EnterpricePlanUpdateConfirmationModal: FC<
  EnterpricePlanUpdateConfirmationModalProps
> = ({ isOpen, handleClose, planId }) => {
  const [errorText, setErrorText] = useState('');

  const { updateEnterprisePaymentPlan, isUpdatingEnterprisePaymentPlan } = useUpdateEnterpricePaymentPlans({
    setErrorText,
    onSuccess: () => {
      handleClose();
      toast.success('Payment Plan Updated');
    },
  });


  const handleUpdate = () =>
    updateEnterprisePaymentPlan({
      plan: planId,
    });

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <br />
        <UpdateIcon />
        <br />
        <Typography variant="h4">
          Change Payment plan?
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <LoadingButton
            onClick={handleUpdate}
            loading={isUpdatingEnterprisePaymentPlan}
            variant="contained"
            loadingPosition="start"
            startIcon={<CheckOutlinedIcon />}
          >
            Yes, Update My Payment Plan
          </LoadingButton>
          <Button onClick={handleClose} variant="outlined" color="secondary">
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default EnterpricePlanUpdateConfirmationModal;
